import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import StudentModals from "../studentModals";
import StudentSidebar from "./studentSidebar";
import StudentBreadcrumb from "./studentBreadcrumb";
import useQuery, { _post } from "../../../Utils/Helper";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { academicYear } from "../../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFTEMPLATE from "../../../report/grade-report/components/PDFTEMPLATE";

interface Subject {
  subject: string;
  max_marks: number;
  min_marks: number;
  marks_obtained: number;
  result_status: string;
}

interface ExamResults {
  [examType: string]: Subject[];
}
 
const StudentResult = () => {
  const routes = all_routes;
  const q = useQuery();
  const {user} = useSelector((state: any) => state.auth)
  const admission_no = user?.admission_no;
  console.log("Admission No:", admission_no,user);

  const _form = {
    academic_year: "2024/2025"
  };
  const [form, setForm] = React.useState(_form);

  const [examResults, setExamResults] = useState<any[]>([]);

  const fetchResults = useCallback(async () => {
    try {
      await _post(
        "get_student_results",
        { admission_no:user.admission_no },
        (response) => {
          if (response.success) {
            // alert(JSON.stringify(response.results))
            setExamResults(response.results);
          } else {
            console.error("Failed to fetch results:", response.data.message);
          }
        },
        (err) => {
          console.error("Error fetching results:", err);
        }
      );
    } catch (err) {
      console.error("Error fetching results:", err);
    }
  }, [admission_no]);

  useEffect(() => {
    fetchResults();
  }, [fetchResults]);

  function groupDataByExamNameAndTerm(data:any[]) {
    return data.reduce((groups, item) => {
      // Create a unique key using exam_name and term
      const key = `${item.exam_name}: ${item.class_name} (${item.academic_year} -${item.term})`;
      // Initialize the group if it doesn't exist
      if (!groups[key]) {
        groups[key] = [];
      }
      // Add the current record to the group
      groups[key].push(item);
      return groups;
    }, {});

  }
  const groupedResults = groupDataByExamNameAndTerm(examResults);

const renderAccordionItems = () => {
  if (!examResults || Object.keys(groupedResults).length === 0) {
    return <p>No results available</p>;
  }

  return Object.keys(groupedResults).map((examType, index) => {
    const subjects = groupedResults[examType] || [];
    const subjectCount = subjects.length;
    // Assuming each subject is out of 100 marks
    const maxMarks = subjectCount * 100;
    const marksObtained = subjects.reduce(
      (sum:number, item:any) => sum + (item.total_score || 0),
      0
    );
    const percentage =
      subjectCount > 0 ? ((marksObtained / maxMarks) * 100).toFixed(2) : "0.00";
    // const  pdfLinkRef= useRef()
    return (
      <div className="accordion-item" key={index}>
        <h2 className="accordion-header">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse-${examType}`}
            aria-expanded="true"
            aria-controls={`collapse-${examType}`}
          >
            <span className="avatar avatar-sm bg-success me-2">
              <i className="ti ti-checks" />
            </span>
            {examType}
          </button>
        </h2>
        <div
          id={`collapse-${examType}`}
          className="accordion-collapse collapse show"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            {/* Exam Result List */}
            <div className="table-responsive">
              <table className="table">
                <thead className="thead-light">
                  <tr>
                    <th>Subject</th>
                    <th>Score</th>
                    <th>Grade</th>
                    <th>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {subjects.length > 0 ? (
                    subjects.map((item:any, idx:number) => (
                      <tr key={idx}>
                        <td>{item?.subject}</td>
                        <td>{item?.total_score}</td>
                        <td>{item?.grade}</td>
                        <td className="text-end">
                          <span className="badge badge-soft-success d-inline-flex align-items-center">
                            <i className="ti ti-circle-filled fs-5 me-1" />
                            {item.remark}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No subjects available for this exam type.
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="bg-dark text-white" colSpan={5}>
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Rank: N/A</span>
                        <span>Total Marks: {maxMarks}</span>
                        <span>Marks Obtained: {marksObtained}</span>
                        <span>Percentage: {percentage}</span>
                        <h6 className="fw-normal text-white">
                          Result:{" "}
                          <span className="text-success">
                            {Number(percentage) >= 40 ? "Pass" : "Fail"}
                          </span>
                        </h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* <PDFDownloadLink
              document={<PDFTEMPLATE student={examResults} />}
              fileName={`${examResults[0]?.student_name.replace(
                /\s+/g,
                "_"
              )}_grade_report.pdf`} // File name with student's name
              // ref={pdfLinkRef}
            >
              <a className="pdf-download-button">Download PDF</a>
            </PDFDownloadLink> */}
          </div>
        </div>
      </div>
    );
  });
};

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* List */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail}?admission_no=${admission_no}`}
                        className="nav-link"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to={`${routes.studentTimetable}?admission_no=${admission_no}`}
                        className="nav-link"
                      >
                        <i className="ti ti-table-options me-2" />
                        Time Table
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to={`${routes.studentLeaves}?admission_no=${admission_no}`}
                        className="nav-link "
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Leave &amp; Attendance
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to={`${routes.studentFees}?admission_no=${admission_no}`}
                        className="nav-link "
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to={`${routes.studentResult}?admission_no=${admission_no}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Exam &amp; Results
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to={`${routes.studentLibrary}?admission_no=${admission_no}`}
                        className="nav-link"
                      >
                        <i className="ti ti-books me-2" />
                        Library
                      </Link>
                    </li> */}
                  </ul>
                  {/* /List */}
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="mb-3">Exams &amp; Results</h4>
                      <div className="d-flex align-items-center flex-wrap">
                        <div className="dropdown mb-3 me-2">
                          <label>Academic Year </label>
                          <CommonSelect
                            className="select"
                            options={academicYear}
                            handleChange={(newValue: SingleValue<Option>) =>
                              setForm((prev) => ({
                                ...prev,
                                academic_year: newValue ? newValue.value : ""
                              }))
                            }
                            defaultValue={{
                              label: form.academic_year,
                              value: form.academic_year
                            }}
                            // onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div
                        className="accordions-items-seperate"
                        id="accordionExample"
                      >
                        {renderAccordionItems()}
                        {/* <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              <span className="avatar avatar-sm bg-success me-2">
                                <i className="ti ti-checks" />
                              </span>
                              Monthly Test (Apr)
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">

                              <div className="table-responsive">
                                <table className="table">
                                  <thead className="thead-light">
                                    <tr>
                                      <th>Subject</th>
                                      <th>Max Marks</th>
                                      <th>Min Marks</th>
                                      <th>Marks Obtained</th>
                                      <th className="text-end">Result</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>English (150)</td>
                                      <td>100</td>
                                      <td>35</td>
                                      <td>59</td>
                                      <td className="text-end">
                                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                                          <i className="ti ti-circle-filled fs-5 me-1" />
                                          Pass
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Mathematics (214)</td>
                                      <td>100</td>
                                      <td>35</td>
                                      <td>69</td>
                                      <td className="text-end">
                                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                                          <i className="ti ti-circle-filled fs-5 me-1" />
                                          Pass
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Physics (120)</td>
                                      <td>100</td>
                                      <td>35</td>
                                      <td>79</td>
                                      <td className="text-end">
                                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                                          <i className="ti ti-circle-filled fs-5 me-1" />
                                          Pass
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Chemistry (110)</td>
                                      <td>100</td>
                                      <td>35</td>
                                      <td>89</td>
                                      <td className="text-end">
                                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                                          <i className="ti ti-circle-filled fs-5 me-1" />
                                          Pass
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>AgricScience (140)</td>
                                      <td>100</td>
                                      <td>35</td>
                                      <td>99</td>
                                      <td className="text-end">
                                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                                          <i className="ti ti-circle-filled fs-5 me-1" />
                                          Pass
                                        </span>
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td className="bg-dark text-white">
                                        Rank : 30
                                      </td>
                                      <td className="bg-dark text-white">
                                        Total : 500
                                      </td>
                                      <td
                                        className="bg-dark text-white"
                                        colSpan={2}
                                      >
                                        Marks Obtained : 400
                                      </td>
                                      <td className="bg-dark text-white text-end">
                                        <div className="d-flex align-items-center justify-content-end">
                                          <span className="me-2">
                                            Percentage : 80.50
                                          </span>
                                          <h6 className="fw-normal text-white">
                                            Result :{" "}
                                            <span className="text-success">
                                              {" "}
                                              Pass
                                            </span>
                                          </h6>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
            
                            </div>
                          </div>
                        </div> */}
                     
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default StudentResult;
